import { CheckGlobalResourceAccessTask } from '@/Ship/Tasks/CheckGlobalResourceAccessTask'

import { ClientTendersList } from '../Components/ClientTendersList'
import { TENDER_RESOURCE } from '../Contracts/ITender'

export interface ClientTendersTabProps {
    /** Значення форми клієнта; без `uuid` (новий клієнт) тендерів ще немає */
    record: { uuid?: unknown; '@id'?: unknown; title?: unknown } | undefined
}

/**
 * Чи бачить користувач тендери взагалі: колекційне `read_collection`
 * (K, M, L; «Фінанси» без них — ні, Q2.13). За ним картка клієнта ховає
 * вкладку, а не показує 403 усередині.
 */
export const canReadTenders = (): boolean => CheckGlobalResourceAccessTask(TENDER_RESOURCE, 'read_collection')

/**
 * Публічне API контейнера тендерів для картки клієнта (`SPEC-022` §3.4,
 * `SPEC-025` §3.5): вміст вкладки «Тендер». Розміщує вкладку в
 * `ClientFormTemplate` наряд оболонки (Н-025.4) — тут лише вміст.
 *
 * Без права на тендери або без збереженого клієнта — нічого.
 */
export const ClientTendersTab = ({ record }: ClientTendersTabProps) => {
    const uuid = typeof record?.uuid === 'string' && record.uuid !== '' ? record.uuid : null

    if (uuid === null || !canReadTenders()) return null

    const iri = record?.['@id']
    const title = record?.title

    return (
        <ClientTendersList
            client={{
                uuid,
                ...(typeof iri === 'string' && iri !== '' ? { '@id': iri } : {}),
                ...(typeof title === 'string' && title !== '' ? { title } : {}),
            }}
        />
    )
}
